export const headerCell = {
  textAlign: 'center',
}
